import { useRef } from 'react'
import { Card, Button } from 'react-bootstrap'
import { useCuit } from './Hooks'

function Comprobante() {
  const linkRef = useRef()
  const cuit = useCuit()
  return (
    <>
      <Card className="text-center p-5">
        <Card.Title>Alta de contribuyente finalizada</Card.Title>
        <Card.Text>
          Descargue su comprobante en pdf desde el botón debajo.
        </Card.Text>
        <Card.Text>
          Debe presentarse a Control Urbano para poder terminar su tramite,
          muchas gracias.
        </Card.Text>

        <a style={{ display: 'none' }} ref={linkRef} href="/#">
          #
        </a>
        <Button
          className="w-50 mx-auto mt-5"
          variant="outline-primary"
          onClick={() =>
            fetch('/ddjj/alta/api/comprobante')
              .then((res) => res.blob())
              .then((blob) => {
                const href = window.URL.createObjectURL(blob)
                const a = linkRef.current
                a.download = `Comprobante de Alta - ${cuit}.pdf`
                a.href = href
                a.click()
                a.href = ''
              })
              .catch((err) => console.log(err))
          }
        >
          Descargar PDF
        </Button>
      </Card>
    </>
  )
}

export default Comprobante
